import {
  Button,
  cn,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Alert,
  AlertDescription,
  AlertTitle,
  Label,
  Checkbox,
  Heading,
} from "@ogt/ui";

import type { LabelMode } from "../../components/Map/transitMap/constants";

interface ToolsPopoverProps {
  isDesktop: boolean;
  streetViewVisible: boolean;
  mobileSidebarOpen: boolean;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  hasAnyFilter: boolean;
  copied: boolean;
  onCopyLink: () => void;
  onClearAll: () => void;
  labelMode: LabelMode;
  onLabelModeChange: (mode: LabelMode) => void;
}

function ToolsPopover({
  isDesktop,
  streetViewVisible,
  open,
  onOpenChange,
  hasAnyFilter,
  copied,
  onLabelModeChange,
  onCopyLink,
  onClearAll,
  labelMode,
}: ToolsPopoverProps) {
  return (
    <div
      className={cn(
        "absolute  md:bottom-auto md:left-auto left-auto md:top-3 right-2 top-16 md:right-[180px] mb-8 md:mb-0",
        streetViewVisible ? "" : "z-5"
      )}
    >
      <Popover open={open} onOpenChange={onOpenChange}>
        <PopoverTrigger asChild>
          <Button
            className="h-[44px]! min-h-[44px]! py-0!"
            variant="primary"
            size="large"
            showIcon
            activated={open}
            aria-pressed={open}
            iconName={open ? "x" : "menu"}
            iconPosition="left"
          >
            {open ? "Stäng verktyg" : "Verktyg"}
          </Button>
        </PopoverTrigger>

        <PopoverContent align={"end"} sideOffset={8} alignOffset={0}>
          <Heading as="h3">Kartverktyg</Heading>
          <hr className="my-4 border-t-[var(--semantic-color-divider-secondary)]" />
          <Button
            showIcon
            iconName="copy"
            variant="secondary"
            onClick={onCopyLink}
            className="mb-2 w-full"
          >
            Kopiera länk till kartan
          </Button>
          <Button
            showIcon
            iconName="trashcan"
            variant="secondary"
            onClick={onClearAll}
            disabled={!hasAnyFilter}
            className="disabled:opacity-70 w-full"
          >
            Rensa alla val
          </Button>
          <hr className="my-4 border-t-[var(--semantic-color-divider-secondary)]" />

          <div className="flex flex-col " id="placenames-section">
            <Heading as="h5">Platsnamn</Heading>

            <Label className="flex flex-row! items-center gap-2 cursor-pointer">
              <Checkbox
                id="place-names-toggle"
                checked={labelMode === "icon+name"}
                onCheckedChange={(v) =>
                  onLabelModeChange(v === true ? "icon+name" : "icon")
                }
              />
              <span>Visa platsnamn</span>
            </Label>
          </div>

          {copied && (
            <Alert variant="success" dismissible showIcon className="mt-4">
              <AlertTitle>
                <span className="pr-[70px] flex">Kopierad!</span>{" "}
              </AlertTitle>
              <AlertDescription>
                Nu kan du enkelt dela länken vidare.
              </AlertDescription>
            </Alert>
          )}
        </PopoverContent>
      </Popover>
    </div>
  );
}

export default ToolsPopover;
